var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".52917mm",
    height: "6.7469mm",
    viewBox: "0 0 .52917 6.7469",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.28 -100.19)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.54,
    x2: 100.54,
    y1: 100.19,
    y2: 106.94,
    fill: "none",
    stroke: "#0055a0",
    strokeMiterlimit: 10,
    strokeWidth: ".52917px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.5863108a74b914e0feb81f731bfb5fd6.svg";
export { ForwardRef as ReactComponent };